import en from './en.json'
import zh from './zh.json'

export const languages = {
  en,
  zh,
}

export const defaultLocale = 'zh'